import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from "@icon/Icon";
/**
 * Phones: the top row of a sheet or full-screen layer. With `onBack` it is a Back button with
 * the parent's name; without it just a title. Used where the app header and its Close bar are not
 * there (the mobile menu's sub-lists, pages outside the mobile shell).
 */
const MobileBackRow = ({ title, onBack }) => _jsx("div", { className: "uxpcore_mobileback", children: onBack
        ? _jsxs("button", { className: "uxpcore_mobileback__button", onClick: onBack, children: [_jsx(Icon, { icon: ['phl', 'caret-left'] }), _jsx("span", { children: title })] })
        : _jsx("div", { className: "uxpcore_mobileback__title", children: title }) });
export default MobileBackRow;
